import { useLocation, Outlet, useNavigate, useParams } from 'react-router'

import { Tabs, TabsList, TabsTrigger } from '@/components/elements/tabs'
import { Layout } from '@/components/Layout'

export const AccountManagement = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { entityId } = useParams()

  // Detect active tab from URL
  const getActiveTab = () => {
    if (location.pathname.includes('/details')) return 'details'
    if (location.pathname.includes('/jobs')) return 'jobs'
    if (location.pathname.includes('/credit-bank')) return 'credit-bank'
    return 'details'
  }

  const handleTabChange = (value) => {
    navigate(`/accounts/${entityId}/account-management/${value}`)
  }

  return (
    <Layout breadcrumbs={['Admin', 'Account Management']}>
      <Layout.Heading title="Account Management" />

      <Tabs value={getActiveTab()} onValueChange={handleTabChange} className="mt-4">
        <TabsList>
          <TabsTrigger value="details">Account Details</TabsTrigger>
          <TabsTrigger value="jobs">Jobs</TabsTrigger>
          <TabsTrigger value="credit-bank">Credit Bank</TabsTrigger>
        </TabsList>

        <div className="mt-4">
          <Outlet />
        </div>
      </Tabs>
    </Layout>
  )
}
